<template>
    <div>
        <div class="caption">{{ pack.packName.toLowerCase() }}</div>
        <div class="caption">({{ pack.value }} {{ pack.unitName.toLowerCase() }})</div>
    </div>
</template>

<script>
    export default {
        name: "Pack",
        props:['pack'],
        computed: {

        }
    }
</script>

<style scoped>

</style>
